export enum CampaignOMStatus {
  CANCELLED = "CANCELLED",
  CANCELLING = "CANCELLING",
  COMPLETE = "COMPLETE",
  COMPLETE_WITH_ERRORS = "COMPLETE_WITH_ERRORS",
  DRAFT = "DRAFT",
  INCOMPLETE = "INCOMPLETE",
  RUNNING = "RUNNING",
  SCHEDULED = "SCHEDULED",
}
